// Read more product description
document.addEventListener("click", function(e) {
  if (!e.target.closest("[data-read-more-toggle]")) return;

  const button = e.target.closest("[data-read-more-toggle]");
  const wrapper = button.closest(".product__block");
  const description = wrapper.querySelector(".pdp-read-more-description");
  const text = button.querySelector(".pdp-read-more-text");

  description.classList.toggle("is-open");
  button.classList.toggle("is-open");

  if (description.classList.contains("is-open")) {
    text.textContent = "Read Less";
  } else {
    text.textContent = "Read More";
  }
});